<template>
  <div class="Singer">
    <transition name="Singer__deco">
      <div class="Singer__deco" v-if="showTitle">
        <img class="Singer__pallette" :src="require('./pallette.png')" />
        <div class="Singer__title">
          <img :src="require('./welcome_' + lang + '.png')" />
        </div>
      </div>
    </transition>
    <transition name="Singer__content">
      <div v-if="showVideo" class="Singer__content">
        <video ref="video" autoplay playsinline muted :src="require('./video.mp4')" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Singer',
  props: ['found'],
  data: () => ({
    showVideo: false,
    lock: false,
    showTitle: false
  }),
  watch: {
    'found': 'play'
  },
  beforeDestroy() {
    this.$parent.forceFound = false
    if(this.$t1) this.$t1.kill()
    if(this.$t2) this.$t1.kill()
  },
  methods: {
    play() {
      if(this.lock || !this.found) return

      this.lock = true
      this.showVideo = true
      this.$parent.forceFound = true
      this.$nextTick(() => {
        this.$refs.video.pause()
        this.$refs.video.currentTime = 0
        this.$refs.video.play()
        TweenLite.to('.Capture__btn', .5, { autoAlpha: 0 })
        this.$t1 = TweenLite.delayedCall(8, () => {
          this.showTitle = true
          this.showVideo = false
          TweenLite.to('.Capture__btn', .5, { autoAlpha: 1 })
        })
      })
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Singer
  height 100%
  position fixed
  left 0px
  width 100%
  top 0px

  &__pallette
    position absolute
    width 100%
    height 100%
    left 0
    top 0

  &__deco
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    transition transform 3s, opacity 1s
    &-enter
    &-leave-active
      opacity 0

  &__title
    width 220px
    position absolute
    left 50%
    top 30px
    transform translateX(-50%)

  &__content
    position fixed
    top 0px
    left 0px
    right 0px
    bottom 0px
    transition opacity 4s
    &-enter
    &-leave-active
      opacity 0
    video
      object-fit cover
      object-position center center
      width 100%
      height 100%

</style>
